import RunnerDebugUI from '@/components/Runner/RunnerDebugUI'
import RunnerEvent from '@/components/Runner/RunnerEvent'
import RunnerPersona from '@/components/Runner/RunnerPersona'
import RunnerPopin from '@/components/Runner/RunnerPopin'
import RunnerTooltip from '@/components/Runner/RunnerTooltip'
import RunnerUICountdown from '@/components/Runner/RunnerUICountdown'
import RunnerUIHeader from '@/components/Runner/RunnerUIHeader'
import RunnerUIMobile from '@/components/Runner/RunnerUIMobile'
import RunnerUIPause from '@/components/Runner/RunnerUIPause'
import { useRunnerState } from '@/composables/useRunnerState'

export default function RunnerUI() {
  const { gameState, isIdle, isLoading } = useRunnerState()

  const hasPauseUI = import.meta.env.VITE_RUNNER_NO_PAUSE_UI !== 'true'
  const hasDebugger = import.meta.env.VITE_RUNNER_SHOW_DEBUG === 'true'
  const hasObstacle = gameState.obstacle != null || gameState.turningPoint !== null

  return (
    <>
      <div className='pointer-events-none'>
        <RunnerUIHeader />
        <RunnerEvent visible={gameState.turningPoint != null} id={gameState.turningPoint} />
        <RunnerEvent visible={gameState.obstacle != null} id={gameState.obstacle} />
        {!isIdle && !isLoading && !hasObstacle && <RunnerPersona />}
        <RunnerUICountdown />
        <RunnerPopin />
        <RunnerTooltip />
        <RunnerUIMobile isVisible={!isIdle && !isLoading && !hasObstacle} />
        {hasPauseUI && <RunnerUIPause />}
      </div>
      {hasDebugger && <RunnerDebugUI />}
    </>
  )
}
